module.exports = __webpack_public_path__ + "img/rotate-icon.efcf8ce4.svg";